// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__EhNeu","header":"Dashboard_header__cIDNz","center":"Dashboard_center__QNu2Q"};